export const DateFormat = {
    DD_MMM_YYYY: "dd MMM yyyy",
    YYYY_MM_DD: "yyyy-MM-dd",
}